export const IconInvalidPassword = (props) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4272 4.90625L5.25391 14.0796"
      stroke="#FC5555"
      strokeWidth="1.72"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25391 4.90625L14.4272 14.0796"
      stroke="#FC5555"
      strokeWidth="1.72"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
